import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

let cache = null;
let inflight = null;
const listeners = new Set();

export const fetchTenantModules = async (force = false) => {
  if (cache && !force) return cache;
  if (!inflight) {
    inflight = api.get('/tenant/modules')
      .then((r) => { cache = r.data; listeners.forEach((l) => l(cache)); return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const resetTenantModules = () => { cache = null; };

export function useTenantModules() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    listeners.add(setData);
    fetchTenantModules().catch(() => setData({ modules: { pdv: true } }));
    return () => listeners.delete(setData);
  }, []);
  return { modules: data?.modules || null, planId: data?.plan_id, planName: data?.plan_name, loaded: !!data };
}
